import type { TOC } from '@ember/component/template-only';

interface TableDrawerSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class="!my-0 top-0 right-0 z-999 fixed bg-light-grey" ...attributes>
    <div class="w-[548px] max-w-[548px] h-screen overflow-auto border-box shadow-lg">
      {{yield}}
    </div>
  </div>
</template> satisfies TOC<TableDrawerSignature>;
